/* eslint-disable no-unused-vars */
import React, { useState, useEffect, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { getLocale } from "react-i18nify";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";

import { Routes, Route, Link, useParams, NavLink } from "react-router-dom";

// import { UploadContextProvider as UploadProvider } from "src/context/UploadProductContext";
import { getUserTokenBalance } from "src/api/tokenTransaction";

import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import { Avatar, Box } from "@mui/material";
// import Badge from "@mui/material/Badge";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";

import { Speed as IconSpeed } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import CollectionsIcon from "@mui/icons-material/Collections";
import HistoryIcon from "@mui/icons-material/History";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import CampaignIcon from "@mui/icons-material/Campaign";
import InsightsIcon from "@mui/icons-material/Insights";

import {
  IconCandyBox,
  IconStarOutline,
  IconUserGroup,
  IconSeller,
  IconSampleRequest,
  IconQuotation,
  IconSaleQuotation,
  IconOrder,
  IconSaleOrder,
  IconShopThisMood,
  IconBlog,
  IconExclusiveLogo,
  IconProfile,
  IconTerm,
  IconTooltip,
  IconLandingPage,
  IconWallplast,
  IconPromoCodeOutlined,
  IconShipping,
  IconRefund,
  IconProductType,
  IconPictureOutline,
  IconCertificate,
  IconToken,
  IconDocument,
  IconWallet,
  // IconOrderRequest,
} from "./icons";

import device from "src/styles/device";
import { convertIntToCurrency } from "src/common";
import Chip from "src/components/core/Chip";

// import { getNotiNewOrder } from "src/api/order";

import { useAuth } from "./hooks/useAuth";
import usePathPattern from "src/hooks/usePathPattern";
import useDeviceSize from "src/hooks/useDeviceSize";

import PageNotFound from "./pages/PageNotFound";
import Forbidden from "./pages/Forbidden";
import Protected from "./pages/Protected";
import Line from "./pages/Line";
// import Unauthorized from "./pages/Unauthorized";
import Login from "./pages/Login";

import Auth from "./components/auth/Auth";
import ProductList from "./modules/product/ProductList";
import ApproveProduct from "./modules/product/ProductPreview";
import CreateUploadProduct from "./modules/product/upload";
import Profile from "./components/profile/Profile";
import TermDetail from "./components/term/TermDetail";
import SellerList from "./components/seller/SellerList";
import SampleList from "./components/sample/SampleList";
import SellerDetail from "./components/seller/SellerDetail";
import SampleDetail from "./components/sample/SampleDetail";
import ReviewList from "./components/review/ReviewList";
import TutorialVideo from "./components/tutorial/TutorialVideo";
import BlogList from "./modules/blog/BlogList";
import BlogCreate from "./modules/blog/BlogCreate/";
import QuoDraftList from "./modules/quotation-draft/QuotaionDraftList";
import CreateQuoDraft from "./modules/quotation-draft/CreateQuoDraft";
import QuoDraftDetail from "./modules/quotation-draft/QuotationDraftDetail";
import ProductLogList from "./components/log/ProductLogList";
import ShopThisMood from "./modules/shop-this-mood/ShopThisMood";
import MoodRoomList from "./modules/shop-this-mood/MoodRoomList";
import SaleOrderList from "./modules/sale-features/SaleOrderList";
import SaleCreateOrder from "./modules/sale-features/SaleOrderCreateAndUpdate";
import SaleOrderDetail from "./modules/sale-features/SaleOrderDetail";
import LandingPage from "./modules/landing-page/LandingPage";
import ExclusiveDeal from "./modules/exclusive-deal/ExclusiveDeal";
import DealGroupList from "./modules/exclusive-deal/DealGroupList";
import WallplastList from "./modules/wallplast/WallplastList";
import WallplastDetail from "./modules/wallplast/WallplastDetail";
import PromoCodeList from "./modules/promo-code/PromoCodeList";
import CreatePromoCode from "./modules/promo-code/CreatePromoCode";
import PreviewPromoCode from "./modules/promo-code/PreviewPromoCode";
import OrderList from "./modules/order/purchase-order/OrderList";
import OrderDetail from "./modules/order/purchase-order/OrderDetail";
import SellerOrderList from "./modules/seller-order/SellerOrderList";
import SellerOrderDetail from "./modules/seller-order/SellerOrderDetail";
import UserList from "./modules/user-management/customer/UserList";
import UserDetail from "./modules/user-management/customer/Detail";
import AdminList from "./modules/user-management/admin/AdminList";
import AdminDetail from "./modules/user-management/admin/Detail";
import ShippingList from "./modules/order/shipping-order/admin/ShippingList";
import ShippingDetail from "./modules/order/shipping-order/admin/Detail";
import SellerShippingList from "./modules/order/shipping-order/seller/ShippingList";
import SellerShippingDetail from "./modules/order/shipping-order/seller/Detail";
import CancelRefundList from "./modules/order/cancel-refund/CancelRefundList";
import CancelDetail from "./modules/order/cancel-refund/CancelDetail";
// import Unauthorized from "./pages/Unauthorized";
import CertificateList from "./modules/certificate/CertificateList";
import CertificateForm from "./modules/certificate/CertificateForm";
import CertificateDetail from "./modules/certificate/CertificateDetail";
import CollectionList from "./modules/collections/CollectionLIst";
import CollectionForm from "./modules/collections/CollectionForm";
// import IconOrderRequest from "./icons/IconOrderRequest";
import PerformanceDashboard from "./modules/dashboard/sales-performance";
import ProductDashboard from "./modules/dashboard/product-insights";
import ProductTypeList from "./modules/product-type/ProductTypeList";
import NewQuotationList from "./modules/quotation/QutationList";
import CreateQuotation from "./modules/quotation/CreateQuotation";
import QuotaionDetail from "./modules/quotation/QuotationDetail";
import GenerateHistory from "./modules/generate-history";
import TokenTopUp from "./modules/token-topup";
import SellerTokenOrder from "./modules/seller-token-order";
import TokenOrderList from "./modules/token-order/TokenOrderList";
import TokenOrderDetail from "./modules/token-order/TokenOrderDetail";
import SpecialTokenTopup from "./modules/special-token-topup";
import SellerTokenTransaction from "./modules/seller-token-transaction";

const routes = [
  {
    path: "/term",
    breadcrumbs: [
      {
        text: "Term",
        now: true,
        link: "/term",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <TermDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/list",
    breadcrumbs: [
      {
        text: "รายการสินค้า",
        now: true,
        link: "/product/list",
        replace: false,
      },
    ],
    accessKey: ["products.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ProductList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller/list",
    breadcrumbs: [
      {
        text: "ผู้ขาย",
        now: true,
        link: "/seller/list",
        replace: false,
      },
    ],
    accessKey: ["sellers.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller/detail/:sellerId",
    breadcrumbs: [
      {
        text: "Seller",
        now: true,
        link: "/seller/list",
        replace: false,
      },
    ],
    accessKey: ["sellers.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/quotation/list",
    breadcrumbs: [
      {
        text: "ใบเสนอราคา",
        now: true,
        link: "/quotation/list",
        replace: false,
      },
    ],
    accessKey: ["quotations.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <NewQuotationList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/quotation/detail/:quotationId",
    breadcrumbs: [
      {
        text: "ใบเสนอราคา",
        now: true,
        link: "/quotation/list",
        replace: false,
      },
    ],
    accessKey: ["quotations.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <QuotaionDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/quotation/new",
    breadcrumbs: [
      {
        text: "ใบเสนอราคา",
        now: true,
        link: "/quotation/list",
        replace: false,
      },
    ],
    accessKey: ["quotations.can_create"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreateQuotation {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/quotation/new/:quotationId",
    breadcrumbs: [
      {
        text: "ใบเสนอราคา",
        now: true,
        link: "/quotation/list",
        replace: false,
      },
    ],
    accessKey: ["quotations.can_replace"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreateQuotation {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sample/list",
    breadcrumbs: [
      {
        text: "ขอสินค้าตัวอย่าง",
        now: true,
        link: "/sample/list",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_sampleRequest"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SampleList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sample/detail/:sampleId",
    breadcrumbs: [
      {
        text: "Sample Request",
        now: true,
        link: "/sample/list",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_sampleRequest"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SampleDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/user/list",
    breadcrumbs: [
      {
        text: "ลูกค้า",
        now: true,
        link: "/user/list",
        replace: false,
      },
    ],
    accessKey: ["users.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <UserList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/user/detail/:userId",
    breadcrumbs: [
      {
        text: "Sample Request",
        now: true,
        link: "/user/list",
        replace: false,
      },
    ],
    accessKey: ["users.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <UserDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/upload",
    breadcrumbs: [
      {
        text: "Product List",
        now: false,
        link: "/product/list",
        replace: false,
      },
      {
        text: "Upload Product",
        now: true,
        link: `/product/upload`,
        replace: true,
      },
    ],
    accessKey: ["products.can_create"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreateUploadProduct {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/upload/:productId",
    breadcrumbs: [
      {
        text: "Product List",
        now: false,
        link: "/product/list",
        replace: false,
      },
      {
        text: "Upload Product",
        now: true,
        link: `/product/upload`,
        replace: true,
      },
    ],
    accessKey: ["products.can_edit"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreateUploadProduct {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/approve/:productId",
    breadcrumbs: [
      {
        text: "Product List",
        now: false,
        link: "/product/list",
        replace: false,
      },
      {
        text: "Approve Product",
        now: true,
        link: `/product/approve`,
        replace: true,
      },
    ],
    accessKey: ["products.can_approve"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ApproveProduct {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/preview/:productId",
    breadcrumbs: [
      {
        text: "Product List",
        now: false,
        link: "/product/list",
        replace: false,
      },
      {
        text: "Preview Product",
        now: true,
        link: `/product/preview`,
        replace: true,
      },
    ],
    accessKey: ["products.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ApproveProduct {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/order/list",
    breadcrumbs: [
      {
        text: "รายการสั่งซื้อ",
        now: true,
        link: "/order/list",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_purchaseOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <OrderList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/order/detail/:orderId",
    breadcrumbs: [
      {
        text: "รายการสั่งซื้อ",
        now: true,
        link: "/order/detail",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_purchaseOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <OrderDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/shipping/list",
    breadcrumbs: [
      {
        text: "Shipping List",
        now: true,
        link: "/shipping/list",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_shippingOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ShippingList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/shipping/detail/:orderId",
    breadcrumbs: [
      {
        text: "Shipping Detail",
        now: true,
        link: "/shipping/detail",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_shippingOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ShippingDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/cancel/list",
    breadcrumbs: [
      {
        text: "Cancel/Refund",
        now: true,
        link: "/cancel/list",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_cancelOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CancelRefundList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/cancel/detail/:orderId",
    breadcrumbs: [
      {
        text: "Cancel/Refund Detail",
        now: true,
        link: "/cancel/detail",
        replace: false,
      },
    ],
    accessKey: ["orders.can_view_cancelOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CancelDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/review/list",
    breadcrumbs: [
      {
        text: "รีวิวสินค้า",
        now: true,
        link: "/review/list",
        replace: false,
      },
    ],
    accessKey: ["reviews.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ReviewList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/certificate/list",
    breadcrumbs: [
      {
        text: "รายการใบรับรอง",
        now: true,
        link: "/certificate/list",
        replace: false,
      },
    ],
    accessKey: ["certificates.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CertificateList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/certificate/create",
    breadcrumbs: [
      {
        text: "รายการใบรับรอง",
        now: true,
        link: "/certificate/list",
        replace: false,
      },
      {
        text: "รายละเอียดใบรับรอง",
        now: true,
        link: "/certificate/create",
        replace: false,
      },
    ],
    accessKey: ["certificates.can_create"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CertificateForm {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/certificate/edit/:certificateId",
    breadcrumbs: [
      {
        text: "รายการใบรับรอง",
        now: true,
        link: "/certificate/list",
        replace: false,
      },
      {
        text: "รายละเอียดใบรับรอง",
        now: true,
        link: "/certificate/create",
        replace: false,
      },
    ],
    accessKey: ["certificates.can_edit"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CertificateForm {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/certificate/detail/:certificateId",
    breadcrumbs: [
      {
        text: "รายการใบรับรอง",
        now: true,
        link: "/certificate/list",
        replace: false,
      },
      {
        text: "รายละเอียดใบรับรอง",
        now: true,
        link: "/certificate/create",
        replace: false,
      },
    ],
    accessKey: ["certificates.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CertificateDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/blog/list",
    breadcrumbs: [
      {
        text: "Blog List",
        now: true,
        link: "/blog/list",
        replace: false,
      },
    ],
    accessKey: ["features.can_manage_blog"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <BlogList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/blog/create",
    breadcrumbs: [
      {
        text: "Blog List",
        now: true,
        link: "/blog/list",
        replace: false,
      },
      {
        text: "Create Blog",
        now: true,
        link: "/blog/create",
        replace: false,
      },
    ],
    accessKey: ["features.can_manage_blog"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <BlogCreate {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/blog/edit/:blogId",
    breadcrumbs: [
      {
        text: "Blog List",
        now: true,
        link: "/blog/list",
        replace: false,
      },
      {
        text: "Edit Blog",
        now: true,
        link: "/blog/edit",
        replace: false,
      },
    ],
    accessKey: ["features.can_manage_blog"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <BlogCreate {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-quotation/list",
    breadcrumbs: [
      {
        text: "Quotation Sale",
        now: true,
        link: "/sale-quotation/list",
        replace: false,
      },
    ],
    accessKey: [
      "sale_features.can_view_adminQuotation",
      "sale_features.can_view_saleQuotation",
    ],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <QuoDraftList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-quotation/new",
    breadcrumbs: [
      {
        text: "Create Quotation Sale",
        now: true,
        link: "/sale-quotation/new",
        replace: false,
      },
    ],
    accessKey: ["sale_features.can_create_saleQuotation"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreateQuoDraft {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-quotation/edit/:quotationId",
    breadcrumbs: [
      {
        text: "Edit Quotation Sale",
        now: true,
        link: "/sale-quotation/new",
        replace: false,
      },
    ],
    accessKey: ["sale_features.can_create_saleQuotation"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreateQuoDraft {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-quotation/detail/:quotationId",
    breadcrumbs: [
      {
        text: "Quotation Sale detail",
        now: true,
        link: "/sale-quotation/detail/:quotationId",
        replace: false,
      },
    ],
    accessKey: [
      "sale_features.can_view_adminQuotation",
      "sale_features.can_view_saleQuotation",
    ],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <QuoDraftDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/profile",
    breadcrumbs: [
      {
        text: "Profile",
        now: true,
        link: `/profile`,
        replace: true,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <Profile {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/logs",
    breadcrumbs: [
      {
        text: "Logs",
        now: true,
        link: "/product/logs",
        replace: false,
      },
    ],
    accessKey: ["products.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ProductLogList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product/logs/:itemcode",
    breadcrumbs: [
      {
        text: "Logs",
        now: true,
        link: "/product/logs",
        replace: false,
      },
    ],
    accessKey: ["products.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ProductLogList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/tutorial",
    breadcrumbs: [
      {
        text: "Tutorial",
        now: true,
        link: `/tutorial`,
        replace: true,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <TutorialVideo {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/shop-this-mood",
    breadcrumbs: [
      {
        text: "Shop This Mood",
        now: true,
        link: `/shop-this-mood`,
        replace: true,
      },
    ],
    accessKey: ["features.can_manage_shopThisMood"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ShopThisMood {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/shop-this-mood/:roomId",
    breadcrumbs: [
      {
        text: "Shop This Mood",
        now: true,
        link: `/shop-this-mood/:roomId`,
        replace: false,
      },
    ],
    accessKey: ["features.can_manage_shopThisMood"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <MoodRoomList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-order/list",
    breadcrumbs: [
      {
        text: "Sale Order",
        now: true,
        link: `/sale-order/list`,
        replace: false,
      },
    ],
    accessKey: ["sale_features.can_view_saleOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SaleOrderList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-order/create",
    breadcrumbs: [
      {
        text: "Create Sale Order",
        now: true,
        link: `/sale-order/create`,
        replace: false,
      },
    ],
    accessKey: ["sale_features.can_create_saleOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SaleCreateOrder {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-order/edit/:orderId",
    breadcrumbs: [
      {
        text: "Edit Sale Order",
        now: true,
        link: `/sale-order/create/:orderId`,
        replace: false,
      },
    ],
    accessKey: ["sale_features.can_view_saleOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SaleCreateOrder {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/sale-order/detail/:orderId",
    breadcrumbs: [
      {
        text: "Sale Order Detail",
        now: true,
        link: `/sale-order/detail/:orderId`,
        replace: false,
      },
    ],
    accessKey: ["sale_features.can_view_saleOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SaleOrderDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/exclusive-deal",
    breadcrumbs: [
      {
        text: "XCLUSIVE Deal",
        now: true,
        link: `/exclusive-deal`,
        replace: true,
      },
    ],
    accessKey: ["features.can_manage_xclusiveDeal"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ExclusiveDeal {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/exclusive-deal/:groupId",
    breadcrumbs: [
      {
        text: "XCLUSIVE Deal",
        now: true,
        link: `/exclusive-deal/:groupId`,
        replace: false,
      },
    ],
    accessKey: ["features.can_manage_xclusiveDeal"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <DealGroupList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/landing-page",
    breadcrumbs: [
      {
        text: "Landing Page",
        now: true,
        link: `/landing-page`,
        replace: true,
      },
    ],
    accessKey: ["features.can_manage_landingPage"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <LandingPage {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/promo-code/list",
    breadcrumbs: [
      {
        text: "Promo Code List",
        now: true,
        link: `/promo-code/list`,
        replace: false,
      },
    ],
    accessKey: ["promo_codes.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <PromoCodeList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/promo-code/create",
    breadcrumbs: [
      {
        text: "Create Promo Code",
        now: true,
        link: `/promo-code/create`,
        replace: false,
      },
    ],
    accessKey: ["promo_codes.can_create"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreatePromoCode {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/promo-code/edit/:codeId",
    breadcrumbs: [
      {
        text: "Edit Promo Code",
        now: true,
        link: `/promo-code/edit/:codeId`,
        replace: false,
      },
    ],
    accessKey: ["promo_codes.can_edit"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CreatePromoCode {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/promo-code/preview/:codeId",
    breadcrumbs: [
      {
        text: "Preview Promo Code",
        now: true,
        link: `/promo-code/preview/:codeId`,
        replace: false,
      },
    ],
    accessKey: ["promo_codes.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <PreviewPromoCode {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/wallplast/list",
    breadcrumbs: [
      {
        text: "Order",
        now: true,
        link: "/wallplast/list",
        replace: false,
      },
    ],
    accessKey: ["wallplast.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <WallplastList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/wallplast/detail/:id",
    breadcrumbs: [
      {
        text: "Wallplast",
        now: true,
        link: `/wallplast/detail/:id`,
        replace: false,
      },
    ],
    accessKey: ["wallplast.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <WallplastDetail {...rest} />
        </Protected>
      );
    },
  },
  // Seller Routes
  {
    path: "/seller-order/list",
    breadcrumbs: [
      {
        text: "Seller Order",
        now: true,
        link: "/seller-order/list",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerOrderList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller-order/detail/:orderId",
    breadcrumbs: [
      {
        text: "Seller Order",
        now: true,
        link: "/seller-order/list",
        replace: false,
      },
      {
        text: "Detail",
        now: true,
        link: "/seller-order/detail/:orderId",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerOrderDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller-shipping/list",
    breadcrumbs: [
      {
        text: "Shipping list",
        now: true,
        link: "/seller-shipping/list",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerShippingList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller-shipping/detail/:orderId",
    breadcrumbs: [
      {
        text: "Shipping Order",
        now: true,
        link: "/seller-shipping/list/",
        replace: false,
      },
      {
        text: "Detail",
        now: true,
        link: "/seller-shipping/detail/:orderId",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerShippingDetail {...rest} />
        </Protected>
      );
    },
  },
  // {
  //   path: "/line",
  //   breadcrumbs: [],
  //   element: (props) => {
  //     const { isAllowed, ...rest } = props;
  //     return (
  //       <Protected isAllowed={isAllowed}>
  //         <Line {...rest} />
  //       </Protected>
  //     );
  //   },
  // },
  {
    path: "/dashboard-sales-performance",
    breadcrumbs: [
      {
        text: "Dashboard",
        now: true,
        link: "/dashboard",
        replace: false,
      },
      {
        text: "Sales Performance",
        now: true,
        link: "/dashboard-sales-performance",
        replace: false,
      },
    ],
    allow: [1, 3],
    accessKey: ["dashboards.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <PerformanceDashboard {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/dashboard-product-insights",
    breadcrumbs: [
      {
        text: "Dashboard",
        now: true,
        link: "/dashboard",
        replace: false,
      },
      {
        text: "Product Insights",
        now: true,
        link: "/dashboard-product-insights",
        replace: false,
      },
    ],
    allow: [1, 3],
    accessKey: ["dashboards.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ProductDashboard {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/admin/list",
    breadcrumbs: [
      {
        text: "ผู้ดูแลระบบ",
        now: true,
        link: "/admin/list",
        replace: false,
      },
    ],
    accessKey: ["admins.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <AdminList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/admin/detail/:userId",
    breadcrumbs: [
      {
        text: getLocale() === "th" ? "รายละเอียดผู้ดูแลระบบ" : "Admin detail",
        now: true,
        link: "/admin/detail/:userId",
        replace: false,
      },
    ],
    accessKey: ["admins.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <AdminDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/collection/list",
    breadcrumbs: [
      {
        text: "คอลเลคชัน",
        now: true,
        link: "/collection/list",
        replace: false,
      },
    ],
    accessKey: ["collections.can_view"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CollectionList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/collection/create",
    breadcrumbs: [
      {
        text: "สร้างคอลเลคชัน",
        now: true,
        link: "/collection/create",
        replace: false,
      },
    ],
    accessKey: ["collections.can_create"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CollectionForm {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/collection/edit/:collectionId",
    breadcrumbs: [
      {
        text: "แก้ไขคอลเลคชัน",
        now: true,
        link: "/collection/edit/:collectionId",
        replace: false,
      },
    ],
    accessKey: ["collections.can_edit"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <CollectionForm {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/product-type/list",
    breadcrumbs: [
      {
        text: "ประเภทสินค้า",
        now: true,
        link: "/product-type/list",
        replace: false,
      },
    ],
    accessKey: ["features.can_manage_productType"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <ProductTypeList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/generate-history",
    breadcrumbs: [
      {
        text: "คลังภาพ AI",
        now: true,
        link: "/generate-history",
        replace: false,
      },
    ],
    allow: [1, 3],
    accessKey: ["token_features.can_view_generateHistory"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <GenerateHistory {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/token-topup",
    breadcrumbs: [
      {
        text: "เติมเครดิต",
        now: true,
        link: "/token-topup",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <TokenTopUp {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller-token-order",
    breadcrumbs: [
      {
        text: "ประวัติการเติมเครดิต",
        now: true,
        link: "/seller-token-order",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerTokenOrder {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/seller-token-transaction",
    breadcrumbs: [
      {
        text: "ประวัติการใช้เครดิต",
        now: true,
        link: "/seller-token-transaction",
        replace: false,
      },
    ],
    allow: [3],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SellerTokenTransaction {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/token-order",
    breadcrumbs: [
      {
        text: "ธุรกรรมผู้ขายทั้งหมด",
        now: true,
        link: "/token-order",
        replace: false,
      },
    ],
    accessKey: ["token_features.can_manage_tokenOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <TokenOrderList {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/token-order/:orderId",
    breadcrumbs: [
      {
        text: "รายละเอียดธุรกรรมผู้ขาย",
        now: true,
        link: "/token-order/:orderId",
        replace: false,
      },
    ],
    accessKey: ["token_features.can_manage_tokenOrder"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <TokenOrderDetail {...rest} />
        </Protected>
      );
    },
  },
  {
    path: "/special-token-topup",
    breadcrumbs: [
      {
        text: "เติมเครดิตพิเศษ",
        now: true,
        link: "/special-token-topup",
        replace: false,
      },
    ],
    accessKey: ["token_features.can_manage_topupToken"],
    element: (props) => {
      const { isAllowed, ...rest } = props;
      return (
        <Protected isAllowed={isAllowed}>
          <SpecialTokenTopup {...rest} />
        </Protected>
      );
    },
  },
];

const drawerWidth = 260;

const S = {};

S.AppBarHeader = styled.div`
  display: flex;
  align-items: center;
`;

S.NewBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  margin-left: 5px;
  background: linear-gradient(
    45deg,
    oklch(62.3% 0.214 259.815) 10%,
    oklch(62.7% 0.265 303.9) 50%,
    oklch(65.6% 0.241 354.308) 90%
  );
  background-size: 300% 300%;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  color: white;
  animation: gradientShift 3s ease-in-out infinite;

  @keyframes gradientShift {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

S.AppBarContainer = styled.div`
  background: #ffffff !important;
  width: 100%;
  height: 75px;
  display: flex;
  justify-content: space-between;
  padding: 0 32px;

  @media ${device.tabletL} {
    padding: 0 20px;
    height: 64px;
  }
`;

S.SubHeaderText = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #bebebe;
  display: block;
`;

S.HeaderText = styled.div`
  color: #252525;
  margin: auto 0;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const AppBar = muiStyled(MuiAppBar, {
  backgroundColor: "#ffffff",
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  backgroundColor: "#ffffff",
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [theme.breakpoints.down("md")]: {
    boxShadow: "4px 2px 8px 0px rgba(0, 0, 0, 0.1)",
  },
  ...(open && {
    backgroundColor: "#ffffff",
    display: "flex",
    justifyContent: "space-between",
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = muiStyled("div")(({ theme, isDesktop }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 2),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  ...(isDesktop
    ? {
        justifyContent: "flex-end",
      }
    : {
        justifyContent: "space-between",
      }),
}));

// const StyledBadge = muiStyled(Badge)(({ theme }) => ({
//   "& .MuiBadge-badge": {
//     right: "-20%",
//     top: "50%",
//     padding: "0 4px",
//   },
// }));

/**
 * @notice check admin view's permission
 * @param {String[]} allowList -
 * @param {Object} permission - user permission object
 */
const checkIsAllowMenu = (allowList, permission) => {
  if (!permission) return true; // if didn't setting permission, allow all menu
  return allowList.some((permPath) => {
    const [group, perm] = permPath.split(".");
    return permission[group]?.[perm] === true;
  });
};

const AppMenuItemComponent = ({ onClick, link, children, ...rest }) => {
  // If link is not set return the orinary ListItem
  if (!link || typeof link !== "string") {
    return (
      <ListItem {...rest} onClick={onClick}>
        {children}
      </ListItem>
    );
  }

  // Return a LitItem with a link component
  return (
    <ListItem
      {...rest}
      component={forwardRef(function Nav(props, ref) {
        return <NavLink {...props} ref={ref} />;
      })}
      to={link}
    >
      {children}
    </ListItem>
  );
};

const AppMenuItem = ({
  name,
  link,
  rootPath,
  Icon,
  items = [],
  customBadge,
  isTablet,
}) => {
  const currentPath = usePathPattern(routes.map((route) => route.path));
  //   const {
  //     state: { session },
  //   } = useContext(AuthContext);
  const { user, userPermission } = useAuth();

  const isExpandable = items && items.length > 0;
  const [open, setOpen] = useState(true);

  function handleClick() {
    setOpen(!open);
  }

  const isCurrentPath = currentPath?.includes(rootPath);
  const MenuItemRoot = (
    <AppMenuItemComponent
      //   className={classes.menuItem}
      link={link}
      onClick={handleClick}
      sx={{
        paddingTop: 0,
      }}
    >
      <ListItemButton
        sx={{
          backgroundColor: isCurrentPath ? "#F7CECB" : "#ffffff",
          // margin: "0px 15px",
          color: isCurrentPath ? "#e04132" : "#252525",
          borderRadius: "12px",
          p: 1,
          "&:hover": {
            backgroundColor: isCurrentPath ? "#F7CECB" : "#ffffff",
            opacity: 0.8,
            // margin: "0px 15px",
            color: isCurrentPath ? "#e04132" : "#252525",
            borderRadius: isExpandable ? "12px" : "16px",
          },
          ".MuiTypography-root": {
            color: isCurrentPath ? "#e04132" : "#252525",
          },
        }}
      >
        {/* Display an icon if any */}
        {!!Icon && (
          // <ListItemIcon className={classes.menuItemIcon}>
          <ListItemIcon sx={{ pl: 1, minWidth: "38px" }}>
            <Icon
              className="xxxxx"
              fill={isCurrentPath ? "#e04132" : "#252525"}
              style={{ color: isCurrentPath ? "#e04132" : "#252525" }}
            />
          </ListItemIcon>
        )}
        {customBadge ? (
          customBadge({
            isCurrentPath,
            children: <ListItemText primary={name} />,
          })
        ) : (
          <ListItemText
            primary={name}
            sx={{
              my: isExpandable ? 0 : 0.5,
              span: {
                lineHeight: isExpandable ? 1 : 1.5,
              },
            }}
          />
        )}

        {/* Display the expand menu if the item has children */}
        {isExpandable && !open && <ExpandMoreIcon />}
        {isExpandable && open && <ExpandLessIcon />}
      </ListItemButton>
    </AppMenuItemComponent>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      {/* <Divider /> */}
      <List disablePadding>
        {items.map((item, index) => {
          const showMenu =
            item.allow.includes(user?.role_id) && // check user role permission
            (user?.role_id === 1
              ? checkIsAllowMenu(item.accessKey, userPermission) // check admin view's permission
              : true) && // allow all user role if permission haven't been set
            (user?.role_id === 3
              ? item?.sellerStatusAllow?.includes(user?.seller?.is_approve) // check seller approve status
              : true) && // if not seller, allow all
            item.devices?.includes(isTablet ? "tablet" : "desktop"); // check device size
          return showMenu && <AppMenuItem {...item} key={index} />;
        })}
      </List>
    </Collapse>
  ) : null;

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
};

const Layout = (props) => {
  const navigate = useNavigate();
  const {
    user,
    userPermission,
    isLoggedIn,
    logout,
    userTokenBalance,
    checkGenerateTokenBalance,
  } = useAuth();
  const [deviceWidth] = useDeviceSize();

  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  const [isDesktop, setIsDesktop] = useState(true);
  const [isTablet, setIsTablet] = useState(false);
  // const [notiNewOrder, setNotiNewOrder] = useState(0);

  useEffect(() => {
    if (!user || user?.role_id === 1) return;

    checkGenerateTokenBalance();
  }, [checkGenerateTokenBalance, user]);

  useEffect(() => {
    if (deviceWidth > 835 && deviceWidth < 1024) {
      setIsDesktop(false);
      setIsTablet(false);
      setIsDrawerOpen(false);
      setIsMobileDrawerOpen(false);
    } else if (deviceWidth <= 835) {
      setIsDesktop(false);
      setIsTablet(true);
      setIsDrawerOpen(false);
      setIsMobileDrawerOpen(false);
    } else {
      setIsDesktop(true);
      setIsTablet(false);
      setIsDrawerOpen(true);
      setIsMobileDrawerOpen(false);
    }
  }, [deviceWidth]);

  const handleOpenMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (isDesktop) setIsDrawerOpen(true);
    else setIsDrawerOpen(isMobileDrawerOpen);
  }, [isMobileDrawerOpen, isDesktop]);

  let { customerId, contactId, projectId, checkinId, reportId, saleId } =
    useParams();

  var mapObj = {
    ":contactId": `${contactId}`,
    ":customerId": `${customerId}`,
    ":projectId": `${projectId}`,
    ":checkinId": `${checkinId}`,
    ":reportId": `${reportId}`,
    ":saleId": `${saleId}`,
  };

  var re = new RegExp(Object.keys(mapObj).join("|"), "gi");

  // const fetchNotiNewOrder = async () => {
  //   const {
  //     data: { count },
  //   } = await getNotiNewOrder();
  //   setNotiNewOrder(count);
  // };

  useEffect(() => {
    if (window.location.pathname === "/") {
      navigate("/dashboard-sales-performance");
    }

    if (!isDesktop) setIsMobileDrawerOpen(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  // Get current path pattern to render breadcrumbs
  const currentPath = usePathPattern(routes.map((route) => route.path));
  const currentRoute = routes.filter((route) => route.path === currentPath)[0];

  const menuItems = [
    {
      name: "Dashboard",
      allow: [1, 3], // 1 : admin, 3 : seller
      sellerStatusAllow: [1], // ! 0 : current is not approve by admin yet, 1 : approved by admin, 2 : rejected by admin
      accessKey: ["dashboards.can_view"],
      devices: ["desktop", "tablet"],
      items: [
        {
          name: "Sales Performance",
          link: "/dashboard-sales-performance",
          rootPath: "/dashboard-sales-performance",
          allow: [1, 3],
          sellerStatusAllow: [1],
          accessKey: ["dashboards.can_view"],
          devices: ["desktop", "tablet"],
          Icon: (width, height, fill) => (
            <IconSpeed
              sx={{
                width,
                height,
                fill,
              }}
            />
          ),
        },
        {
          name: "Product Insights",
          link: "/dashboard-product-insights",
          rootPath: "/dashboard-product-insights",
          allow: [1, 3],
          sellerStatusAllow: [1],
          accessKey: ["dashboards.can_view"],
          devices: ["desktop", "tablet"],
          Icon: (width, height, fill) => (
            <InsightsIcon
              sx={{
                width,
                height,
                fill,
              }}
            />
          ),
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "สินค้า" : "Product"}`,
      allow: [1, 3],
      sellerStatusAllow: [1],
      accessKey: [
        "products.can_view",
        "reviews.can_view",
        "certificates.can_view",
      ],
      devices: ["desktop"],
      items: [
        {
          name: `${getLocale() === "th" ? "รายการสินค้า" : "Product"}`,
          link: "/product/list",
          rootPath: "/product",
          allow: [1, 3],
          sellerStatusAllow: [1],
          accessKey: ["products.can_view"],
          devices: ["desktop"],
          Icon: IconCandyBox,
          customBadge: ({ isCurrentPath, children }) => {
            return (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {children}
                <S.NewBadge>
                  <AutoAwesome sx={{ fontSize: 12, mr: 0.5 }} />
                  AI Tool
                </S.NewBadge>
              </Box>
            );
          },
        },
        {
          name: `${getLocale() === "th" ? "รีวิวสินค้า" : "Product Review"}`,
          link: "/review/list",
          rootPath: "/review",
          allow: [1],
          accessKey: ["reviews.can_view"],
          devices: ["desktop"],
          Icon: IconStarOutline,
        },
        {
          name: `${getLocale() === "th" ? "ใบรับรอง" : "Certificates"}`,
          link: "/certificate/list",
          rootPath: "/certificate",
          allow: [1],
          accessKey: ["certificates.can_view"],
          devices: ["desktop"],
          Icon: IconCertificate,
        },
      ],
    },
    {
      name: `Credit AI`,
      allow: [1, 3],
      sellerStatusAllow: [1],
      accessKey: [
        "token_features.can_view_generateHistory",
        "token_features.can_manage_tokenOrder",
        "token_features.can_manage_topupToken",
      ],
      devices: ["desktop"],
      items: [
        {
          name: `${getLocale() === "th" ? "คลังภาพ AI" : "AI Image History"}`,
          link: "/generate-history",
          rootPath: "/generate-history",
          allow: [1, 3],
          sellerStatusAllow: [1],
          accessKey: ["token_features.can_view_generateHistory"],
          devices: ["desktop"],
          Icon: IconPictureOutline,
          customBadge: ({ isCurrentPath, children }) => {
            return (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {children}
                <S.NewBadge>
                  <CampaignIcon sx={{ fontSize: 12, mr: 0.5 }} />
                  ฟีเจอร์ใหม่
                </S.NewBadge>
              </Box>
            );
          },
        },
        {
          name: `${getLocale() === "th" ? "ธุรกรรมผู้ขายทั้งหมด" : "Seller Transaction History"}`,
          link: "/token-order",
          rootPath: "/token-order",
          allow: [1],
          accessKey: ["token_features.can_manage_tokenOrder"],
          devices: ["desktop"],
          Icon: IconDocument,
        },
        {
          name: `${getLocale() === "th" ? "เติมเครดิตพิเศษ" : "Special Credit Topup"}`,
          link: "/special-token-topup",
          rootPath: "/special-token-topup",
          allow: [1],
          accessKey: ["token_features.can_manage_topupToken"],
          devices: ["desktop"],
          Icon: IconWallet,
        },
        {
          name: `${getLocale() === "th" ? "เติมเครดิต" : "Top Up Credit"}`,
          link: "/token-topup",
          rootPath: "/token-topup",
          allow: [3],
          sellerStatusAllow: [1],
          accessKey: ["products.can_view"],
          devices: ["desktop"],
          Icon: IconToken,
          // Icon: IconDocument,
        },
        {
          name: `${getLocale() === "th" ? "ประวัติการเติม" : "Credit Billing History"}`,
          link: "/seller-token-order",
          rootPath: "/seller-token-order",
          allow: [3],
          sellerStatusAllow: [1],
          devices: ["desktop"],
          Icon: IconDocument,
        },
        {
          name: `${getLocale() === "th" ? "ประวัติการใช้เครดิต" : "Credit Usage History"}`,
          link: "/seller-token-transaction",
          rootPath: "/seller-token-transaction",
          allow: [3],
          sellerStatusAllow: [1],
          devices: ["desktop"],
          Icon: (width, height, fill) => (
            <HistoryIcon
              sx={{
                width,
                height,
                fill,
              }}
            />
          ),
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "ผู้ใช้งาน" : "Users"}`,
      allow: [1],
      devices: ["desktop"],
      accessKey: ["users.can_view", "sellers.can_view", "admins.can_view"],
      items: [
        {
          name: `${getLocale() === "th" ? "ลูกค้า" : "Customers"}`,
          link: "/user/list",
          rootPath: "/user",
          allow: [1],
          accessKey: ["users.can_view"],
          devices: ["desktop"],
          Icon: IconUserGroup,
        },
        {
          name: `${getLocale() === "th" ? "ผู้ขาย" : "Sellers"}`,
          link: "/seller/list",
          rootPath: "/seller",
          allow: [1],
          accessKey: ["sellers.can_view"],
          devices: ["desktop"],
          Icon: IconSeller,
        },
        {
          name: `${getLocale() === "th" ? "ผู้ดูแลระบบ" : "Admins"}`,
          link: "/admin/list",
          rootPath: "/admin",
          allow: [1],
          accessKey: ["admins.can_view"],
          devices: ["desktop"],
          Icon: (width, height, fill) => (
            <ManageAccountsOutlinedIcon
              sx={{
                width,
                height,
                fill,
              }}
            />
          ),
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "คำสั่งซื้อ" : "Orders"}`,
      allow: [1],
      accessKey: [
        "quotations.can_view",
        "orders.can_view_sampleRequest",
        "orders.can_view_purchaseOrder",
        "orders.can_view_shippingOrder",
        "orders.can_view_cancelOrder",
        "promo_codes.can_view",
      ],
      devices: ["desktop", "tablet"],
      items: [
        {
          name: `${getLocale() === "th" ? "ใบเสนอราคา" : "Quotation"}`,
          link: "/quotation/list",
          rootPath: "/quotation",
          allow: [1],
          accessKey: ["quotations.can_view"],
          devices: ["desktop"],
          Icon: IconQuotation,
        },
        {
          name: `${getLocale() === "th" ? "ขอสินค้าตัวอย่าง" : "Sample Request"}`,
          link: "/sample/list",
          rootPath: "/sample",
          allow: [1],
          accessKey: ["orders.can_view_sampleRequest"],
          devices: ["desktop"],
          Icon: IconSampleRequest,
        },
        {
          name: `${getLocale() === "th" ? "รายการสั่งซื้อ" : "Purchase Order"}`,
          link: "/order/list",
          rootPath: "/order",
          allow: [1],
          accessKey: ["orders.can_view_purchaseOrder"],
          devices: ["desktop"],
          Icon: IconOrder,
          // customBadge: ({ isCurrentPath, children }) => {
          //   return (
          //     <StyledBadge
          //       sx={{
          //         // "& .MuiBadge-badge": {
          //         //   backgroundColor: isCurrentPath ? "#ffffff" : "#e04132",
          //         //   color: isCurrentPath ? "#e04132" : "#ffffff",
          //         //   border: isCurrentPath
          //         //     ? "2px solid #ffffff"
          //         //     : "2px solid #e04132",
          //         // },
          //         "& .MuiBadge-badge": {
          //           backgroundColor: "#e04132",
          //           color: "#ffffff",
          //           border: "2px solid #e04132",
          //         },
          //       }}
          //       badgeContent={notiNewOrder}
          //       color="primary"
          //     >
          //       {children}
          //     </StyledBadge>
          //   );
          // },
        },
        {
          name: `${getLocale() === "th" ? "รายการจัดส่ง" : "Shipping Order"}`,
          link: "/shipping/list",
          rootPath: "/shipping",
          allow: [1],
          accessKey: ["orders.can_view_shippingOrder"],
          devices: ["desktop", "tablet"],
          Icon: IconShipping,
        },
        {
          name: `${getLocale() === "th" ? "รายการยกเลิก/คืนเงิน" : "Cancel/Refund"}`,
          link: "/cancel/list",
          rootPath: "/cancel",
          devices: ["desktop", "tablet"],
          allow: [1],
          accessKey: ["orders.can_view_cancelOrder"],
          Icon: IconRefund,
        },
        {
          name: `${getLocale() === "th" ? "โค้ดส่วนลด" : "Promo Code"}`,
          link: "/promo-code/list",
          rootPath: "/promo-code",
          allow: [1],
          accessKey: ["promo_codes.can_view"],
          devices: ["desktop"],
          Icon: IconPromoCodeOutlined,
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "เซลล์" : "Sale Features"}`,
      allow: [1],
      accessKey: [
        "sale_features.can_view_adminQuotation",
        "sale_features.can_view_saleQuotation",
        "sale_features.can_view_saleOrder",
      ],
      devices: ["desktop", "tablet"],
      items: [
        {
          name: `${getLocale() === "th" ? "ใบเสนอราคา" : "Sale Quotation"}`,
          link: "/sale-quotation/list",
          rootPath: "/sale-quotation",
          allow: [1],
          accessKey: [
            "sale_features.can_view_adminQuotation",
            "sale_features.can_view_saleQuotation",
          ],
          devices: ["desktop", "tablet"],
          Icon: IconSaleQuotation,
        },
        {
          name: `${getLocale() === "th" ? "สร้างคำสั่งซื้อ" : "Sale Order"}`,
          link: "/sale-order/list",
          rootPath: "/sale-order",
          allow: [1],
          accessKey: ["sale_features.can_view_saleOrder"],
          devices: ["desktop", "tablet"],
          Icon: IconSaleOrder,
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "เครื่องมือทางการตลาด" : "Features"}`,
      allow: [1],
      accessKey: [
        "features.can_manage_landingPage",
        "features.can_manage_xclusiveDeal",
        "features.can_manage_shopThisMood",
        "features.can_manage_blog",
      ],
      devices: ["desktop"],
      items: [
        {
          name: "Landing Page",
          link: "/landing-page",
          rootPath: "/landing-page",
          allow: [1],
          accessKey: ["features.can_manage_landingPage"],
          devices: ["desktop"],
          Icon: IconLandingPage,
        },
        {
          name: "XCLUSIVE Deal",
          link: "/exclusive-deal",
          rootPath: "/exclusive-deal",
          allow: [1],
          accessKey: ["features.can_manage_xclusiveDeal"],
          devices: ["desktop"],
          Icon: IconExclusiveLogo,
        },
        {
          name: "Shop This Mood",
          link: "/shop-this-mood",
          rootPath: "/shop-this-mood",
          allow: [1],
          accessKey: ["features.can_manage_shopThisMood"],
          devices: ["desktop"],
          Icon: IconShopThisMood,
        },
        {
          name: `${getLocale() === "th" ? "บทความ" : "Blog"}`,
          link: "/blog/list",
          rootPath: "/blog",
          allow: [1],
          accessKey: ["features.can_manage_blog"],
          devices: ["desktop"],
          Icon: IconBlog,
        },
        {
          name: "คอลเลคชัน",
          link: "/collection/list",
          rootPath: "/collection",
          allow: [1],
          accessKey: ["collections.can_view"],
          devices: ["desktop"],
          Icon: CollectionsIcon,
        },
        {
          name: `${getLocale() === "th" ? "ประเภทสินค้า" : "Product Type"}`,
          link: "/product-type/list",
          rootPath: "/product-type",
          allow: [1],
          // accessKey: ["features.can_manage_productType"],
          accessKey: ["features.can_manage_landingPage"], // ! temp use landingPage permission
          devices: ["desktop"],
          Icon: IconProductType,
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "คำสั่งซื้อ" : "Orders"}`,
      allow: [3],
      sellerStatusAllow: [1],
      devices: ["desktop", "tablet"],
      items: [
        {
          name: `${getLocale() === "th" ? "รายการจัดส่ง" : "Shipping Order"}`,
          link: "/seller-shipping/list",
          rootPath: "/seller-shipping",
          allow: [3],
          sellerStatusAllow: [1],
          devices: ["desktop", "tablet"],
          Icon: IconShipping,
        },
      ],
    },
    {
      name: `${getLocale() === "th" ? "โปรไฟล์" : "Profile"}`,
      allow: [3],
      sellerStatusAllow: [0, 1],
      devices: ["desktop", "tablet"],
      items: [
        {
          name: `${getLocale() === "th" ? "โปรไฟล์" : "Profile"}`,
          link: "/profile",
          rootPath: "/profile",
          allow: [3],
          sellerStatusAllow: [0, 1],
          devices: ["desktop", "tablet"],
          Icon: IconProfile,
        },
        {
          name: `${getLocale() === "th" ? "ข้อกำหนดและเงื่อนไข" : "Term"}`,
          link: "/term",
          rootPath: "/term",
          allow: [3],
          sellerStatusAllow: [1],
          devices: ["desktop", "tablet"],
          Icon: IconTerm,
        },
        {
          name: `${getLocale() === "th" ? "ขั้นตอนการลงสินค้า" : "Tutorial"}`,
          link: "/tutorial",
          rootPath: "/tutorial",
          allow: [3],
          sellerStatusAllow: [0, 1],
          devices: ["desktop", "tablet"],
          Icon: IconTooltip,
        },
      ],
    },
    {
      name: "Wallplast",
      allow: [1],
      accessKey: ["wallplast.can_view"],
      devices: ["desktop"],
      items: [
        {
          name: `${getLocale() === "th" ? "รายการสั่งซื้อ" : "Order"}`,
          link: "/wallplast/list",
          rootPath: "/wallplast",
          allow: [1],
          accessKey: ["wallplast.can_view"],
          devices: ["desktop"],
          Icon: IconWallplast,
        },
      ],
    },
  ];

  const filteredMenus = menuItems
    .map((item) => {
      if (
        isLoggedIn &&
        item.allow?.includes(user?.role_id) &&
        (user?.role_id === 1 && !!userPermission
          ? checkIsAllowMenu(item.accessKey, userPermission) // check admin view's permission
          : true) && // allow all user role if permission haven't been set
        (user?.role_id === 3
          ? item?.sellerStatusAllow?.includes(user?.seller?.is_approve) // check seller approve status
          : true) && // if not seller, allow all
        item.devices?.includes(isTablet ? "tablet" : "desktop")
      ) {
        if (item.items) {
          const items = item.items.filter(
            (subItem) =>
              isLoggedIn &&
              subItem.allow.includes(user?.role_id) &&
              (user?.role_id === 1
                ? checkIsAllowMenu(subItem.accessKey, userPermission) // check admin view's permission
                : true) && // allow all user role if permission haven't been set
              (user?.role_id === 3
                ? subItem?.sellerStatusAllow?.includes(user?.seller?.is_approve) // check seller approve status
                : true) && // if not seller, allow all
              subItem.devices?.includes(isTablet ? "tablet" : "desktop"),
          );
          item.items = items;
        }
        return item;
      }
      return null; // Ensure a value is returned for all cases
    })
    .filter(Boolean); // Remove null values from the resulting array

  return (
    <Box sx={{ display: "flex", background: "#fff" }}>
      <CssBaseline />

      {isLoggedIn ? (
        <>
          <AppBar
            position="fixed"
            open={isDesktop ? isDrawerOpen : false} // Only apply isDrawerOpen when in desktop mode
          >
            <S.AppBarContainer>
              <S.AppBarHeader>
                <IconButton
                  aria-label="open drawer"
                  onClick={() => {
                    if (isDesktop) {
                      setIsDrawerOpen(!isDrawerOpen);
                    } else {
                      setIsMobileDrawerOpen(!isMobileDrawerOpen);
                    }
                  }}
                  edge="start"
                  sx={{
                    mr: 2,
                    width: 40,
                    height: 40,
                    ...(isDrawerOpen && { display: "block" }),
                    flexShrink: 0,
                  }}
                >
                  <MenuIcon
                    sx={{
                      color: "rgba(0, 0, 0, 0.54)",
                      margin: "auto",
                      display: "flex",
                      width: "24px",
                      height: "24px",
                    }}
                  />
                </IconButton>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  {currentRoute?.breadcrumbs.map((data, index) =>
                    data.now === false ? (
                      <Link
                        sx={{
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "1rem",
                          color: "rgba(0, 0, 0, 0.87)",
                        }}
                        key={`breads` + index}
                        to={
                          data.replace === true
                            ? data.link.replace(re, function (matched) {
                                return mapObj[matched];
                              })
                            : data.link
                        }
                      >
                        {data.text}
                      </Link>
                    ) : (
                      <Typography
                        key="3"
                        sx={{
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "1rem",
                          color: "rgba(0, 0, 0, 0.87)",
                        }}
                      >
                        {data.text}
                      </Typography>
                    ),
                  )}
                </Breadcrumbs>
              </S.AppBarHeader>

              <S.AppBarHeader>
                {user?.role_id === 3 && (
                  <Chip
                    icon={
                      <IconToken width={16} height={16} fill="currentColor" />
                    }
                    label={`${convertIntToCurrency(userTokenBalance.current_balance, false)} ${getLocale() === "th" ? "เครดิต" : "Credits"}`}
                    color="primary"
                    size="small"
                    sx={{
                      mr: { xs: 1, md: 0 },
                      fontSize: "0.625rem",
                      backgroundColor: "#FFF2E7",
                      color: "#E04132",
                      borderRadius: "10px",
                      fontWeight: 500,
                    }}
                  />
                )}
                {deviceWidth > 835 ? (
                  <List
                    sx={{
                      width: "100%",
                      minWidth: 300,
                      padding: "0",
                      maxWidth: 350,
                      bgcolor: "#ffffff",
                      margin: "auto 0",
                      position: "relative",
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                  >
                    <ListItemButton onClick={() => handleOpenMenu()}>
                      <ListItemIcon>
                        <Avatar
                          style={{ margin: "auto 16px" }}
                          src={
                            user?.user_profile_image
                              ? user?.user_profile_image
                              : ""
                          }
                        />
                      </ListItemIcon>

                      <ListItemText>
                        <div style={{ margin: "auto 0" }}>
                          <S.HeaderText>
                            {user?.first_name + " " + user?.last_name}
                          </S.HeaderText>
                          <S.SubHeaderText>
                            {!!user?.admin_permission?.role
                              ? user?.admin_permission?.role?.role_name
                              : user?.role_id === 1
                                ? `Admin`
                                : user?.role_id === 3
                                  ? "Seller"
                                  : "Guest"}
                          </S.SubHeaderText>
                        </div>
                      </ListItemText>

                      {isMenuOpen ? (
                        <ArrowDropUpIcon
                          sx={{ color: "rgba(0, 0, 0, 0.54)" }}
                        />
                      ) : (
                        <ArrowDropDownIcon
                          sx={{ color: "rgba(0, 0, 0, 0.54)" }}
                        />
                      )}
                    </ListItemButton>

                    <Collapse
                      in={isMenuOpen}
                      timeout="auto"
                      unmountOnExit
                      sx={{
                        position: "absolute",
                        backgroundColor: "#ffffff",
                        width: "100%",
                        border: "1px solid rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          sx={{ pl: 4 }}
                          onClick={() => {
                            logout();
                            setIsMenuOpen(!isMenuOpen);
                          }}
                        >
                          <ListItemIcon>
                            <LogoutIcon
                              sx={{ width: "16px", height: "16px" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary="Logout"
                            sx={{
                              color: "#252525",
                              ".css-b5pz79-MuiTypography-root": {
                                fontSize: "0.75rem",
                              },
                            }}
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </List>
                ) : (
                  <List
                    sx={{
                      // width: "100%",
                      padding: "0",
                      maxWidth: 300,
                      bgcolor: "#ffffff",
                      margin: "auto 0",
                      position: "relative",
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                  >
                    <ListItemButton
                      sx={{ px: 0 }}
                      onClick={() => handleOpenMenu()}
                    >
                      <ListItemIcon sx={{ minWidth: "unset" }}>
                        <Avatar
                          // style={{ margin: "auto 16px" }}
                          src={
                            user?.user_profile_image
                              ? user?.user_profile_image
                              : ""
                          }
                        >
                          {!user?.user_profile_image && <PersonIcon />}
                        </Avatar>
                      </ListItemIcon>
                    </ListItemButton>

                    <Collapse
                      in={isMenuOpen}
                      timeout="auto"
                      unmountOnExit
                      sx={{
                        position: "absolute",
                        right: 0,
                        width: "max-content",
                        backgroundColor: "#ffffff",
                        border: "1px solid rgba(0, 0, 0, 0.05)",
                        boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.20)",
                      }}
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          // sx={{ pl: 4 }}
                          onClick={() => {
                            logout();
                            setIsMenuOpen(!isMenuOpen);
                          }}
                        >
                          <ListItemIcon sx={{ minWidth: "unset", mr: 2 }}>
                            <LogoutIcon
                              sx={{ width: "16px", height: "16px" }}
                            />
                          </ListItemIcon>

                          <ListItemText
                            primary="Logout"
                            sx={{
                              fontSize: "1rem",
                              color: "#252525",
                              ".css-b5pz79-MuiTypography-root": {
                                fontSize: "0.75rem",
                              },
                            }}
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </List>
                )}
              </S.AppBarHeader>
            </S.AppBarContainer>
          </AppBar>
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: deviceWidth > 835 ? drawerWidth : 220,
                boxSizing: "border-box",
                overflow: "hidden",
              },
            }}
            // variant="persistent"
            anchor="left"
            // open={open}
            {...(isDesktop
              ? {
                  variant: "persistent",
                  open: isDrawerOpen,
                }
              : {
                  open: isMobileDrawerOpen,
                  onClose: () => setIsMobileDrawerOpen(false),
                })}
          >
            <DrawerHeader isDesktop={isDesktop}>
              <div
                onClick={() => {
                  window.open("https://xsurface.com", "_self");
                }}
                style={{
                  width: "75%",
                  backgroundImage: `url(https://xsurface-images.s3.ap-southeast-1.amazonaws.com/icon/_icon%20set_Logo%20xsurface_w_b.svg)`,
                  backgroundSize: "100%",
                  backgroundRepeat: "no-repeat",
                  cursor: "pointer",
                  ...(isDesktop
                    ? {
                        margin: "24px auto 10px 8px",
                        height: "45px",
                      }
                    : {
                        margin: "20px auto 10px 0",
                        height: "35px",
                      }),
                }}
              ></div>
              {!isDesktop && (
                <IconButton
                  aria-label="close drawer"
                  onClick={() => setIsMobileDrawerOpen(false)}
                  sx={{
                    height: 34,
                    ...(isDrawerOpen && { display: "block" }),
                  }}
                >
                  <CloseIcon
                    sx={{
                      width: "18px",
                      height: "18px",
                      color: "var(--primary-color)",
                      margin: "auto",
                      display: "flex",
                    }}
                  />
                </IconButton>
              )}
            </DrawerHeader>
            <List
              sx={{
                margin: 0,
                overflowY: "scroll",
                "::-webkit-scrollbar": {
                  // width: "4px",
                  // height: "4px",
                  display: "none",
                },
                "::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "::-webkit-scrollbar-thumb": {
                  background: "#b9b9b9",
                  borderRadius: "100px",
                },
                "::-webkit-scrollbar-thumb:hover": {
                  background: "#b9b9b9",
                },
                "::-webkit-scrollbar-corner": {
                  background: "transparent",
                },
              }}
              disablePadding
            >
              {filteredMenus.map((item, index) => {
                return (
                  <AppMenuItem key={index} isTablet={isTablet} {...item} />
                );
              })}
            </List>
          </Drawer>
          <Routes>
            {/* Routes for logged-in users */}
            {routes.map((route, index) => {
              const { element: Component } = route;
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={Component({
                    isAllowed:
                      isLoggedIn &&
                      (route.allow
                        ? route.allow.includes(user?.role_id)
                        : true) && // allow all user role if no allow prop provided
                      (user?.role_id === 1 && route?.accessKey
                        ? checkIsAllowMenu(route?.accessKey, userPermission)
                        : true) && // allow all user role if permission haven't been set
                      (user?.role_id === 3 && route?.sellerStatusAllow
                        ? route.sellerStatusAllow.includes(
                            user?.seller?.is_approve,
                          ) // check seller approve status
                        : true), // if not seller, allow all
                    open: isDesktop ? isDrawerOpen : true, // Only apply isDrawerOpen when in desktop mode
                  })}
                />
              );
            })}
            <Route path="/auth/:token" element={<Auth />} />
            <Route path="/line" element={<Line />} />
            <Route
              path="/403"
              element={<Forbidden open={isDesktop ? isDrawerOpen : true} />}
            />
            <Route
              path="*"
              element={<PageNotFound open={isDesktop ? isDrawerOpen : true} />}
            />
          </Routes>
        </>
      ) : (
        <Routes>
          {/* Always show unauthorized page if not logged in */}
          <Route path="/auth/:token" element={<Auth />} />
          <Route path="*" element={<Login />} />
          {/* <Route path="*" element={<Unauthorized />} /> */}
        </Routes>
      )}
    </Box>
  );
};

export default Layout;
